// Consimțământ GDPR pentru terți non-esențiali (momentan doar embed-ul Cal.com, care
// setează cookie-uri). Fără consimțământ NU se încarcă Cal — CTA-urile cad pe href
// (deschid pagina de booking în tab nou). Alegerea se ține în localStorage.
//
// Fonturile sunt self-hosted (vezi index.css) → niciun terț la load, deci nu intră în
// consimțământ. Singurul terț rămas e Cal, doar la accept.

export const CONSENT_KEY = 'vorba_consent' // 'granted' | 'denied'
export const CONSENT_EVENT = 'vorba-consent-change'

const isBrowser = typeof window !== 'undefined'

export function getConsent() {
  if (!isBrowser) return null
  try {
    return localStorage.getItem(CONSENT_KEY)
  } catch {
    return null
  }
}

export function setConsent(value) {
  if (!isBrowser) return
  try {
    localStorage.setItem(CONSENT_KEY, value)
  } catch {
    /* private mode / blocked storage — ignorăm */
  }
  window.dispatchEvent(new CustomEvent(CONSENT_EVENT, { detail: value }))
}

export const hasConsent = () => getConsent() === 'granted'
